module.exports = "/lucky-balls/img/weager/Page_right.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Page_right.png
// module id = 1169
// module chunks = 0